import { DealsPermissions } from './deals.permissions';
import { DealsRoles } from './deals.roles';

export const dealsMappings = {
  [DealsPermissions.GET_LISTED_DEALS]: [DealsRoles.VIEWER],
  [DealsPermissions.GET_MY_LISTED_DEALS]: [DealsRoles.ASSIGNEE_VIEWER],
  [DealsPermissions.GET_DEAL]: [DealsRoles.VIEWER],
  [DealsPermissions.GET_MY_DEAL]: [DealsRoles.ASSIGNEE_VIEWER],
  [DealsPermissions.ADD_DEAL]: [DealsRoles.CREATOR],
  [DealsPermissions.ADD_MY_DEAL]: [DealsRoles.CREATOR],
  [DealsPermissions.UPDATE_DEAL]: [DealsRoles.EDITOR],
  [DealsPermissions.UPDATE_MY_DEAL]: [DealsRoles.ASSIGNEE_EDITOR],
  [DealsPermissions.SHARE_DEAL_FILES]: [
    DealsRoles.EDITOR,
    DealsRoles.ASSIGNEE_EDITOR,
  ],
  [DealsPermissions.UNSHARE_DEAL_FILES]: [DealsRoles.UNSHARE_DEAL_FILES],
  [DealsPermissions.RAISE_ADDITIONAL_WORK_REQUEST]: [
    DealsRoles.ADDITIONAL_WORK_REQUESTER,
  ],
  [DealsPermissions.GET_COMPLIANCE_FORMS]: [DealsRoles.COMPLIANCE_FORM_VIEWER],
  [DealsPermissions.ARCHIVE_DEAL]: [DealsRoles.ARCHIVER],
  [DealsPermissions.ARCHIVE_MY_DEAL]: [
    DealsRoles.ARCHIVER,
    DealsRoles.ASSIGNEE_ARCHIVER,
  ],

  [DealsPermissions.CREATE_TEMPLATE]: [DealsRoles.TEMPLATE_CREATOR],
  [DealsPermissions.APPLY_TEMPLATE]: [DealsRoles.TEMPLATE_APPLIER],

  [DealsPermissions.MANAGE_PAYMENT_OPTIONS]: [
    DealsRoles.PAYMENT_OPTIONS_MANAGER,
  ],
  [DealsPermissions.MANAGE_PRICE_VISIBILITY]: [
    DealsRoles.PRICE_VISIBILITY_MANAGER,
  ],
  [DealsPermissions.UPDATE_DEAL_REFERENCE]: [DealsRoles.REFERENCE_EDITOR],
  [DealsPermissions.UPDATE_DEAL_DESCRIPTION]: [DealsRoles.DESCRIPTION_EDITOR],
  [DealsPermissions.GET_INTEGRATIONS]: [DealsRoles.INTEGRATIONS_VIEWER],
  [DealsPermissions.BULK_EXPORT]: [DealsRoles.BULK_EXPORTER],
};
